<div
  class="channels-list-item"
  [ngClass]="{
    'channels-list-item--active': active,
    'channels-list-item--unread': channel.unread || (channel.unreadMessages ?? 0) > 0
  }">
  <div class="channels-list-item__row">
    <div class="channels-list-item__avatar">
      <messaging-avatar
        [matTooltip]="
          canShowMembers() && (channel?.totalMembersCount ?? 0) > 2
            ? $safeNavigationMigration(channel?.totalMembersCount) + ' members'
            : null
        "
        [name]="channel?.displayName || 'N A'"
        [initialsSize]="2"
        size="40"
        [src]="$safeNavigationMigration(channel?.imageURL)">
      </messaging-avatar>
    </div>
    <div class="channels-list-item__main">
      <ng-container *hasWorkspaceFeature="[WorkspaceFeatures.showOwnerOnChannelList]">
        @if (ownerName()) {
        <div class="channels-list-item__owner">
          <mat-icon
            class="channels-list-item__owner-icon"
            [svgIcon]="ownerIcon()"
            [style.color]="ownerColorSeed() | authorColor">
          </mat-icon>
          <span
            class="channels-list-item__owner-name"
            [matTooltip]="ownerName()"
            [style.color]="ownerColorSeed() | authorColor">
            {{ ownerName() }}
          </span>
          @if (awayOwnerName()) {
          <span class="channels-list-item__owner-away"> · {{ 'NGX-MESSAGING.by' | translate }} {{ awayOwnerName() }} </span>
          }
        </div>
        }
      </ng-container>
      <div class="channels-list-item__title-container">
        <p
          [matTooltip]="channel.displayName"
          class="channels-list-item__title"
          [ngClass]="{
            'channels-list-item__title--active': active,
            'channels-list-item__title--unread': channel.unread || (channel.unreadMessages ?? 0) > 0
          }">
          @if (channel?.type === ChannelType.GROUP) {
          <mat-icon class="channels-list-item__type-icon" svgIcon="users"></mat-icon>
          } @if (channel?.type === ChannelType.BROADCAST) {
          <mat-icon class="channels-list-item__type-icon" svgIcon="megaphone"></mat-icon>
          } @if (channel?.type === ChannelType.SUPPORT) {
          <mat-icon class="channels-list-item__type-icon" svgIcon="support_agent"></mat-icon>
          }
          <span class="channels-list-item__title-text">{{ channel.displayName }}</span>
        </p>

        <div
          class="channels-list-item__time"
          [ngClass]="{
            'channels-list-item__time--active': active,
            'channels-list-item__time--unread': channel.unread || (channel.unreadMessages ?? 0) > 0
          }">
          <div class="channels-list-item__time-container">
            @if (channel?.lastMessage?.createdAt && isValidDate($safeNavigationMigration(channel.lastMessage.createdAt))) {
            @let msgDate = $safeNavigationMigration(channel.lastMessage.createdAt);
            <span class="channels-list-item__date">
              {{ calcDate(msgDate) ? (msgDate | dateByTimeZone : 'M/dd/yy') : (msgDate | dateByTimeZone : 'h:mm a') }}
            </span>
            }

            <ng-container *hasWorkspaceFeature="[WorkspaceFeatures.canMuteChannels]">
              @if (channel.isMuted) {
              <mat-icon
                class="channels-list-item__mute"
                [ngClass]="{ 'channels-list-item__mute--active': active }"
                svgIcon="volume_off">
              </mat-icon>
              }
            </ng-container>
            @if(channel.pinned){
            <mat-icon [svgIcon]="'bookmark'" class="channels-list-item__bookmark" (click)="pinChat(channel)"> </mat-icon>
            }
          </div>
        </div>
      </div>
      <div class="channels-list-item__meta">
        <div
          class="channels-list-item__status-phone"
          *hasWorkspaceFeature="[WorkspaceFeatures.showStatusInChannelList, WorkspaceFeatures.showPhoneInChannelList]">
          @if (channel.status) {
          <span class="status" [ngClass]="channel.status" *hasWorkspaceFeature="[WorkspaceFeatures.showStatusInChannelList]">
            {{ 'NGX-MESSAGING.FILTER.' + channel.status | uppercase | translate }}
          </span>
          }
          <mat-icon
            class="channels-list-item__service-icon"
            *hasWorkspaceFeature="[WorkspaceFeatures.showChannelPhoneNumberTypeIconOnChannelsList]"
            [svgIcon]="serviceIcon()"
            [attr.aria-label]="serviceIcon()">
          </mat-icon>
          <span class="channels-list-item__phone" *hasWorkspaceFeature="[WorkspaceFeatures.showPhoneInChannelList]">
            {{ $safeNavigationMigration(channel?.phoneNumber) ?? '' | phone }}@if (channel?.lastMessage) {: }
          </span>
        </div>
        <p
          class="channels-list-item__preview"
          [ngClass]="{
            'channels-list-item__preview--active': active,
            'channels-list-item__preview--unread': channel.unread || (channel.unreadMessages ?? 0) > 0
          }">
          @if (channel?.type !== ChannelType.DIRECT_MESSAGE && channel?.lastMessage) {
          <b>{{ $safeNavigationMigration(channel?.lastMessage?.createdBy?.displayName) | shortName }}: </b>
          } @if (channel?.lastMessage) {
          <span class="channels-list-item__preview__body">
            {{ body() || channel?.lastMessage?.body || 'Attachment' | plainText | emoji }}
          </span>
          }
        </p>
        <ng-container *hasWorkspaceFeature="[WorkspaceFeatures.showUnreadsInChannelList]">
          @if (channel.unread || (channel.unreadMessages ?? 0) > 0) {
          <span class="channels-list-item__unreads">
            {{ (channel.unreadMessages ?? 0) > 0 ? channel.unreadMessages : '' }}
          </span>
          }
        </ng-container>
      </div>
    </div>
  </div>
  <button
    type="button"
    class="channels-list-item__more"
    (click)="$event.stopPropagation()"
    [matMenuTriggerFor]="menuChannelItem">
    <mat-icon svgIcon="more_vert"></mat-icon>
  </button>
  <mat-menu #menuChannelItem>
    <button *hasWorkspaceFeature="[WorkspaceFeatures.canPinChannels]" mat-menu-item (click)="pinChat(channel)">
      <mat-icon [svgIcon]="channel.pinned ? 'bookmark_off' : 'bookmark'"></mat-icon>
      {{ channel.pinned ? ('Unpin channel' | translate) : ('Pin channel' | translate) }}
    </button>
    <button *hasWorkspaceFeature="[WorkspaceFeatures.canMuteChannels]" mat-menu-item (click)="muteChat(channel)">
      <mat-icon [svgIcon]="channel.isMuted ? 'volume' : 'volume_off'"></mat-icon>
      {{ channel.isMuted ? ('NGX-MESSAGING.unmuteChannel' | translate) : ('NGX-MESSAGING.muteChannel' | translate) }}
    </button>
    <button mat-menu-item (click)="setAsRead(channel, !(channel.unread || channel.unreadMessages))">
      <mat-icon [svgIcon]="channel.unread || channel.unreadMessages ? 'check_all' : 'check'"></mat-icon>
      {{
        !(channel.unread || channel.unreadMessages)
          ? ('NGX-MESSAGING.mark_as_unread' | translate)
          : ('NGX-MESSAGING.mark_as_read' | translate)
      }}
    </button>
  </mat-menu>
</div>
